import { makeStyles } from "tss-react/mui";

import { styled, Theme, Tooltip } from "@mui/material";

// TODO jss-to-tss-react codemod: '@global' is not supported by tss-react.
// See https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override for alternatives.

export const useStyles = makeStyles()((theme: Theme) => ({
    "@global": {
        body: {
            margin: "0 !important",
        },
    },
    container: {
        height: "100%",
        width: "100%",
        color: theme.palette.emteria.text.inverse,
        backgroundColor: theme.palette.emteria.primary,
    },
    centeredGrid: {
        maxWidth: "50%",
        margin: "0 auto !important",
        "@media (max-width: 768px)": {
            maxWidth: "100%",
        },
    },
    gridItem: {
        "@media (max-width: 768px)": {
            minWidth: "100%",
        },
    },
    card: {
        minHeight: "unset",
        padding: theme.spacing(5, 1),
        backgroundColor: "transparent",
    },
    boldTitle: {
        fontWeight: 600,
    },
    availableAndroidVersionsTitle: {
        marginTop: "1rem !important",
        marginBottom: "1rem !important",
        color: theme.palette.emteria.link,
        fontWeight: 600,
    },
    downloadCard: {
        backgroundColor: theme.palette.emteria.text.inverse,
        color: theme.palette.emteria.primary,
    },
}));

export const LightTooltip = styled(Tooltip)(({ theme }) => ({
    tooltip: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.emteria.text.inverse + " !important",
        color: theme.palette.emteria.primary + " !important",
    },
}));
